@if (column.href(item)) {
  <a [href]="column.href(item)" target="_blank" rel="noopener noreferrer">{{ column.value(item) }}</a>
} @else {
  {{ column.value(item) }}
}
